/* global axios */

import ApiClient from './ApiClient';

class SavedLocationsAPI extends ApiClient {
  constructor() {
    super('saved_locations', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  parse(input) {
    return axios.post(`${this.url}/parse`, { input });
  }
}

export default new SavedLocationsAPI();
